import { render, staticRenderFns } from "./LoadingContentPanel.vue?vue&type=template&id=0ddecb95"
import script from "./LoadingContentPanel.vue?vue&type=script&lang=js"
export * from "./LoadingContentPanel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports